var cov_1xnrz1wdti = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Spin/Spin.tsx",
      hash = "faac90f4fd433c74b0849b02f3b6056a38c8e417",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Spin/Spin.tsx",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 77
        },
        end: {
          line: 8,
          column: 82
        }
      },
      "1": {
        start: {
          line: 10,
          column: 16
        },
        end: {
          line: 17,
          column: 3
        }
      },
      "2": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 19,
          column: 59
        }
      },
      "3": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 23,
          column: 3
        }
      },
      "4": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 54
        }
      },
      "5": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 29,
          column: 3
        }
      },
      "6": {
        start: {
          line: 27,
          column: 36
        },
        end: {
          line: 27,
          column: 63
        }
      }
    },
    fnMap: {
      "0": {
        name: "Spin",
        decl: {
          start: {
            line: 7,
            column: 24
          },
          end: {
            line: 7,
            column: 28
          }
        },
        loc: {
          start: {
            line: 7,
            column: 53
          },
          end: {
            line: 30,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 31
          },
          end: {
            line: 27,
            column: 32
          }
        },
        loc: {
          start: {
            line: 27,
            column: 36
          },
          end: {
            line: 27,
            column: 63
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 21
          },
          end: {
            line: 8,
            column: 30
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 8,
            column: 29
          },
          end: {
            line: 8,
            column: 30
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 15
          }
        }, {
          start: {
            line: 21,
            column: 19
          },
          end: {
            line: 21,
            column: 26
          }
        }],
        line: 21
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Spin/Spin.tsx";
import React from 'react';
import classname from 'classnames';
import { range } from '../utils/numbers';
export default function Spin(props) {
  cov_1xnrz1wdti.f[0]++;

  var _ref = (cov_1xnrz1wdti.s[0]++, props),
      spinClass = _ref.spinClass,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? (cov_1xnrz1wdti.b[0][0]++, 0) : _ref$count,
      render = _ref.render,
      size = _ref.size,
      wrapperClass = _ref.wrapperClass,
      wrapperStyle = _ref.wrapperStyle;

  var style = (cov_1xnrz1wdti.s[1]++, Object.assign({
    width: size,
    height: size
  }, props.style, wrapperStyle));
  var className = (cov_1xnrz1wdti.s[2]++, classname(spinClass('_'), wrapperClass));
  cov_1xnrz1wdti.s[3]++;

  if ((cov_1xnrz1wdti.b[2][0]++, count < 1) || (cov_1xnrz1wdti.b[2][1]++, !render)) {
    cov_1xnrz1wdti.b[1][0]++;
    cov_1xnrz1wdti.s[4]++;
    return (
      /*#__PURE__*/
      React.createElement("div", {
        style: style,
        className: className,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 12
        }
      })
    );
  } else {
    cov_1xnrz1wdti.b[1][1]++;
  }

  cov_1xnrz1wdti.s[5]++;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      style: style,
      className: className,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 26,
        columnNumber: 5
      }
    }, range(count + 1, 1).map(function (i) {
      cov_1xnrz1wdti.f[1]++;
      cov_1xnrz1wdti.s[6]++;
      return render(spinClass, i, props);
    }))
  );
}